export const sorting = (optionA, optionB) => {
	let results = 0;
	if (optionA.order < optionB.order) {
		results = -1;
	}
	if (optionA.order > optionB.order) {
		results = 1;
	}

	return results;
};
